<template>
    <section class="container" id="sponsors" v-if="hasLoaded">
        <h1 class="support-us">Podržavaju nas</h1>
        
        <Sponsor v-bind:sponsor="sponsors.hasOwnProperty('General') && sponsors.General[0]" />
        
        <div class="gold-sponsors" v-if="sponsors.hasOwnProperty('Gold') && sponsors.Gold.length" >
            <template v-for="sponsor in sponsors.Gold">
                <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
            </template>
        </div>

        <section class="other-container" v-if="hasLoaded">
            <template v-if="sponsors.hasOwnProperty('Silver') && sponsors.Silver.length">
                <h2 class="silver-title">Srebrni sponzori</h2>
                <section class="sponsor-category">
                    <template v-for="sponsor in sponsors.Silver">
                        <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
                    </template>
                </section>
            </template>
            
            <template v-if="sponsors.hasOwnProperty('Bronze') && sponsors.Bronze.length">
                <h2>Brončani sponzori</h2>
                <section class="sponsor-category">
                    <template v-for="sponsor in sponsors.Bronze">
                        <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
                    </template>
                </section>
            </template>

            <template v-if="sponsors.hasOwnProperty('Organizational') && sponsors.Organizational.length">
                <h2>Organizacijski partneri</h2>
                <section class="sponsor-category">
                    <template v-for="sponsor in sponsors.Organizational">
                        <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
                    </template>
                </section>
            </template>

            <template v-if="sponsors.hasOwnProperty('Workshop') && sponsors.Workshop.length">
                <h2>Radionice</h2>
                <section class="sponsor-category">
                    <template v-for="sponsor in sponsors.Workshop">
                        <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
                    </template>
                </section>
            </template>

            <template v-if="sponsors.hasOwnProperty('FoodAndBeverage') && sponsors.FoodAndBeverage.length">
                <h2>Hrana i piće</h2>
                <section class="sponsor-category">
                    <template v-for="sponsor in sponsors.FoodAndBeverage">
                        <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
                    </template>
                </section>
            </template>

            <template v-if="sponsors.hasOwnProperty('PrizeGame') && sponsors.PrizeGame.length">
                <h2>Sponzor nagradne igre</h2>
                <section class="sponsor-category">
                    <template v-for="sponsor in sponsors.PrizeGame">
                        <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
                    </template>
                </section>
            </template>

            <template v-if="sponsors.hasOwnProperty('GeneralMedia') && sponsors.GeneralMedia.length">
                <h2>Generalni medijski pokrovitelj</h2>
                <section class="sponsor-category">
                    <Sponsor v-bind:sponsor="sponsors.GeneralMedia[0]" />
                </section>
            </template>

            <template v-if="sponsors.hasOwnProperty('Media') && sponsors.Media.length">
                <h2>Medijski pokrovitelji</h2>
                <section class="sponsor-category">
                    <template v-for="sponsor in sponsors.Media">
                        <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
                    </template>
                </section>
            </template>

            <template v-if="sponsors.hasOwnProperty('Friend') && sponsors.Friend.length">
                <h2>Prijatelji</h2>
                <section class="sponsor-category">
                    <template v-for="sponsor in sponsors.Friend">
                        <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
                    </template>
                </section>
            </template>
        </section>    
    </section>
</template>

<script>
    import Sponsor from '@/components/landing-page/Sponsor.vue';
    import { groupBy } from '@/config';
    
    export default {
        name: 'SponsorList',
        data() {
            return {
                sponsors: {},
                hasLoaded: false
            }
        },
        components: {
            Sponsor
        },
        created() {
            this.$axios.get(`${this.$API_URL}/companies/all-sponsors`).then(response => {
                this.sponsors = groupBy(response.data.sort(
                    (firstSponsor, secondSponsor) => firstSponsor.name.toLowerCase() < secondSponsor.name.toLowerCase() ? -1 : 1), 'sponsorCategory');
                this.hasLoaded = true;
            });
        }
    }
</script>

<style scoped>
section > h1,
section > h2 {
  color: #001618;
  font-family: "Fuse V.2 Display";
  font-weight: 800;
  line-height: 44px;
}

section > h1 {
    font-size: 36px;
    margin-bottom: 70px;
}

section > h2 {
    font-size: 28px;
    margin-top: 20px;
}

section > h2.silver-title {
    margin-top: 100px;
}

section.other-container {
    width: 100%;
}

section.sponsor-category {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.support-us {
    margin-top: 100px;
}

#sponsors {
    margin-bottom: 50px;
}

@media screen and (min-width: 480px) {
    section.sponsor-category {
        justify-content: flex-start;
    }
}

@media screen and (min-width: 768px) {
  section.container {
    display: flex;
    flex-wrap: wrap;
  }

  section > h1 {
    font-size: 54px;
    line-height: 65px;
    margin-bottom: 75px;
  }

  section > h2 {
    font-size: 44px;
    margin-top: 40px;
  }

  .gold-sponsors {
      display: flex;
      flex-direction: column;
      margin-top: 100px;
      width: 100%;
      padding: 0 5%;
  }
}
</style>